import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { CssBaseline, ThemeProvider } from "@material-ui/core";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";

import { App } from "./App/App";
import { store } from "./_redux/store";

// setup fake backend
// import { configureFakeBackend } from "./_helpers";
import theme from "./_theme/theme";
import "./i18n";
import ErrorBoundary from "./_components/ErrorBoundary/ErrorBoundary";

// if (process.env.NODE_ENV !== "production") {
// configureFakeBackend();
// }

const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <MsalProvider instance={msalInstance}>
            <App />
          </MsalProvider>
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById("root")
);
